import { useEffect } from 'react';

import { KeyboardKey } from '@telialt/common-constants/src/keyboard-keys';

const getFocusableElements = (containerElement: HTMLElement) => {
    return Array.from(containerElement?.querySelectorAll('a[href], button') || []) as HTMLElement[];
};

const shiftFocus = (containerElement: HTMLElement, isDown?: boolean) => {
    const focusableElements = getFocusableElements(containerElement);
    const activeElementIndex = focusableElements.findIndex((element) => document.activeElement === element);
    if (isDown && activeElementIndex === -1) {
        focusableElements[0].focus();
    } else if (isDown && activeElementIndex < focusableElements.length - 1) {
        focusableElements[activeElementIndex + 1].focus();
    } else if (!isDown && activeElementIndex > 0) {
        focusableElements[activeElementIndex - 1].focus();
    }
};

export const useKeyboardFocus = (containerElement?: HTMLElement) => {
    useEffect(() => {
        const listener = (event: KeyboardEvent) => {
            if (event.key === KeyboardKey.ArrowDown || event.key === KeyboardKey.ArrowUp) {
                // prevent page scrolling
                event.preventDefault();
            }
            if (event.key === KeyboardKey.ArrowDown) {
                shiftFocus(containerElement, true);
            } else if (event.key === KeyboardKey.ArrowUp) {
                shiftFocus(containerElement, false);
            }
        };

        containerElement?.addEventListener('keydown', listener);

        return () => {
            containerElement?.removeEventListener('keydown', listener);
        };
    }, [containerElement]);
};
